module.exports = __webpack_public_path__ + "img/p64-editorial-board-1992.d5c47df1.jpg";